
import firebase from 'firebase/compat/app';
import * as firebaseui from 'firebaseui'
import 'firebaseui/dist/firebaseui.css';
import { useNavigate } from 'react-router-dom';
import './Login.css';

// Google accounts don't always have a profile photo, and even when
// photoURL is set the image can fail to load (revoked, rate-limited, etc.)
// - either way the account circle needs something to show other than a
// broken image icon.
const DEFAULT_AVATAR = `data:image/svg+xml,${encodeURIComponent(
    "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40'>" +
    "<circle cx='20' cy='20' r='20' fill='#d9d5c9'/>" +
    "<circle cx='20' cy='16' r='7' fill='#fffdf8'/>" +
    "<path d='M6 35c1.2-8.4 8-13.5 14-13.5s12.8 5.1 14 13.5' fill='#fffdf8'/>" +
    "</svg>"
)}`;

const Login = ({
    setIsAuthenticated
}) => {
    const navigate = useNavigate();
    const firebaseConfig = {    
        apiKey: "AIzaSyAwP-nadPN_t7eXfU5BnK6Gw1TMxEuxOmM",
        authDomain: "running-logs.firebaseapp.com",
        };
        firebase.initializeApp(firebaseConfig);

    const uiConfig = {
        signInFlow: "popup", 
        signInSuccessUrl: '/',
        signInOptions: [
            firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        ],
        // tosUrl and privacyPolicyUrl accept either url string or a callback
        // function.
        // Terms of service url/callback.
        tosUrl: '/',
        // Privacy policy url/callback.
        privacyPolicyUrl: function() {
            window.location.assign('/');
        }
    };

    const firebaseWidget = document.getElementById('firebaseui-auth-container')
    if (firebaseWidget) {
        if(firebaseui.auth.AuthUI.getInstance()) {
            const ui = firebaseui.auth.AuthUI.getInstance()
            ui.start('#firebaseui-auth-container', uiConfig)
        } else {
            const ui = new firebaseui.auth.AuthUI(firebase.auth())
            ui.start('#firebaseui-auth-container', uiConfig)
        }
    }

    firebase.auth().onAuthStateChanged(function(user) {
        localStorage.removeItem('accessToken');
        if (!user) {
            setIsAuthenticated(false);
        }
        const firebaseWidget = document.getElementById('firebaseui-auth-container')
        if (firebaseWidget) {
            if (user) {
                // User is signed in. Only flip isAuthenticated once the
                // access token is actually in localStorage - components
                // that gate their first API call on isAuthenticated (e.g.
                // the onboarding redirect) would otherwise fire that call
                // with no token yet, silently fail, and never redirect.
                const photoURL = user.photoURL;
                user.getIdToken().then(function(accessToken) {
                    localStorage.setItem('accessToken', accessToken)
                    const accountImage = document.getElementById('account-image');
                    accountImage.onerror = () => {
                        accountImage.onerror = null;
                        accountImage.src = DEFAULT_AVATAR;
                    };
                    accountImage.src = photoURL || DEFAULT_AVATAR;
                    document.getElementById('firebaseui-auth-container').style.display = 'none';
                    document.getElementById('login-screen').style.display = 'none';
                    document.getElementById('account-controls').style.display = 'flex';
                    document.getElementById('log-out').style.display = 'block';
                    setIsAuthenticated(true);
                });
            } else {
                // User is signed out.
                document.getElementById('account-image').src = DEFAULT_AVATAR;
                    document.getElementById('firebaseui-auth-container').style.display = 'block';
                    document.getElementById('login-screen').style.display = 'flex';
                    document.getElementById('account-controls').style.display = 'none';
                document.getElementById('log-out').style.display = 'none';
                if(firebaseui.auth.AuthUI.getInstance()) {
                    const ui = firebaseui.auth.AuthUI.getInstance()
                    ui.start('#firebaseui-auth-container', uiConfig)
                } else {
                    const ui = new firebaseui.auth.AuthUI(firebase.auth())
                    ui.start('#firebaseui-auth-container', uiConfig)
                }
            }
        }
        document.getElementById('log-out').addEventListener('click', e => { 
            firebase.auth().signOut();
            localStorage.removeItem('accessToken');
            localStorage.removeItem('progress');
        });
    }, function(error) {
        console.error(error);
        const loginError = document.getElementById('login-error');
        if (loginError) {
            loginError.textContent = 'Sign-in failed. Please refresh the page and try again.';
            loginError.style.display = 'block';
        }
    });

    return (
        <>
        <header className="account-header">
            <div className="app-identity">
                <img
                    src="/images/icon-196.png"
                    alt=""
                    className="app-logo"
                />
                <span>Fhionnghaile</span>
            </div>
            <div id="account-controls" className="account-controls">
                <img id="account-image" src={DEFAULT_AVATAR} alt="Signed-in account" />
                <button id="settings-button" onClick={() => navigate('/settings')}>
                    <span aria-hidden="true">⚙</span> Settings
                </button>
                <button id="log-out">Log out</button>
            </div>
        </header>
        <main id="login-screen" className="login-screen">
            <section className="login-card" aria-labelledby="login-title">
                <p className="login-eyebrow">Personal activity goals</p>
                <h1 id="login-title">Your goals, your targets</h1>
                <p className="login-intro">Sign in to view your goals</p>
                <p id="login-error" className="login-error" style={{ display: 'none' }} role="alert"></p>
                <div id="firebaseui-auth-container"></div>
            </section>
        </main>
        </>
    );
}


export default Login;